import { lazy, type ReactNode, Suspense } from 'react'

// Lazy-load the island so motion/framer-motion (~60 KiB gzipped) — reachable in
// the initial bundle only through this header component — ships in its own
// chunk instead of the portal's initial bundle. The impl renders null until the
// day's appointments load, so the null fallback is indistinguishable from the
// existing pre-data state.
const DailyAppointmentsIslandImpl = lazy(
  () => import('#src/components/appointment/DailyAppointmentsIslandImpl.tsx')
)

export default function DailyAppointmentsIsland(): ReactNode {
  return (
    <Suspense fallback={null}>
      <DailyAppointmentsIslandImpl />
    </Suspense>
  )
}
